import IndieStaticSelect from "components/forms/IndieStaticSelect";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { usePhysicalUnitsAPI } from "service/PhysicalUnitsAPIService";

const TENSION_LEVEL_I18N = {
    "Baixa Tensão": "label.tensionLevel.BT",
    "Média Tensão": "label.tensionLevel.MT",
    "Alta Tensão": "label.tensionLevel.AT",
    "Muito Alta Tensão": "label.tensionLevel.MAT",
};

export const PhysicalUnitTensionLevelSelect = (params) => {

    const physicalUnitsAPI = usePhysicalUnitsAPI();
    const [items, setItems] = useState([]);
    const { t } = useTranslation();

    const fetchData = () => {
        physicalUnitsAPI.tensionLevels((data) => {
            const transformedData = data.map((o) => ({
                "value": o.id,
                "label": TENSION_LEVEL_I18N[o.description] ? t(TENSION_LEVEL_I18N[o.description]) : o.description,
            }));
            setItems(transformedData);
        }, (error) => {
            console.error(error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <IndieStaticSelect
            {...params}
            label={t("label.form.tensionLevel")}
            options={items}
            sx={{ width: 200 }}
        />
    );
};
